<template>
  <div class="input-holder">
    <b-form-input type="date"
                  :value="selectedDate"
                  @input="updateValue($event)"
                  :formatter="formatter"/>
    <i class="icon-close btn-clear" @click="clear"></i>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: "DateInput",
  props: {
    value: {
      type: String
    }
  },
  data() {
    return {
      selectedDate: this.value
    };
  },
  methods: {
    formatter(value) {
      return moment(value).format('YYYY-MM-DD');
    },
    updateValue(val) {
      this.selectedDate = val;
      this.$emit('input', val);
    },
    clear() {
      this.selectedDate = '';
      this.$emit('input', '');
    }
  },
  watch: {
    value(val) {
      this.selectedDate = val;
    }
  }
};
</script>

<style scoped lang="scss">
@import '../assets/_scss/_component-base';

.input-holder {
  position: relative;
  &.input-alert {
    input {
      border: 1px dashed $red;
    }
  }
}
.btn-clear {
  cursor: pointer;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 50px;
  margin: auto;
  display: flex;
  align-items: center;
}
</style>